<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                            <p>
                                Revisa las liquidaciones con datos de vehículo,
                                documento y fecha, y exporta la información.
                            </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Liquidaciones
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Visualiza las <b>liquidaciones</b>.
                </div>
            </div>
            <!-- Header con acciones -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-end gap-3">
                <!-- Actions -->
                <div class="flex shrink-0 items-center space-x-3">
                    <button class="hidden sm:inline-flex" mat-flat-button [color]="'primary'"
                        (click)="onExportButtonPressed()" matTooltip="Exportar">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                        <span class="ml-2">Exportar</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Tabla de liquidaciones -->
    <div
        class="liquidations-table-container bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent mx-4">

        <!-- SmartGrid -->
        <div class="pt-1 mx-6">
            <app-smart-grid
                [data]="liquidations()"
                [columnDefs]="columnDefs"
                [config]="gridConfig"
                [loading]="isLoading()"
                [totalRecords]="totalItems()"
                [detailTemplate]="rowDetailsTemplate"
                (pageChanged)="onPageChange($event)"
                (sortChanged)="onSortChange($event)"
                (rowExpansionChanged)="onRowExpansionChanged($event)">
            </app-smart-grid>

            <!-- Row Details Template (nested Material Table) -->
            <ng-template #rowDetailsTemplate let-data="data">
                <div class="flex-1 flex flex-col h-full overflow-hidden ml-4">
                    <div class="flex-1 flex flex-col overflow-hidden my-6">
                        <!-- Header de detalles -->
                        <div
                            class="overflow-y-auto max-h-96 sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
                            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
                                [dataSource]="materialDetailsDataSource" matSort
                                matSortDisableClear>

                                                    <!-- Material -->
                                                    <ng-container matColumnDef="material">
                                                        <th mat-header-cell *matHeaderCellDef
                                                            class="text-left whitespace-nowrap">
                                                            <p class="px-6">Material</p>
                                                        </th>
                                                        <td mat-cell *matCellDef="let detail"
                                                            class="text-left text-uppercase text-sm whitespace-nowrap">
                                                            <p class="px-6">
                                                                <span class="table-text-code">{{ detail.material.code
                                                                    }}</span><br />
                                                                {{ detail.material.name }}
                                                            </p>
                                                        </td>
                                                    </ng-container>

                                                    <!-- Cargado -->
                                                    <ng-container matColumnDef="loaded">
                                                        <th mat-header-cell *matHeaderCellDef class="px-6 ">
                                                            Cargado
                                                        </th>
                                                        <td mat-cell *matCellDef="let detail"
                                                            class=" text-sm whitespace-nowrap">

                                                            <div class="flex items-start">
                                                                <app-unit-measure-display
                                                                    [baseUnit]="{
                                                                        quantity: detail.totalLoaded.base,
                                                                        unitId: detail.baseUnitOfMeasure?._id,
                                                                        unitName: detail.baseUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.baseUnitOfMeasure?.code
                                                                    }"
                                                                    [parallelUnit]="{
                                                                        quantity: detail.totalLoaded.pararell,
                                                                        unitId: detail.pararellUnitOfMeasure?._id,
                                                                        unitName: detail.pararellUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.pararellUnitOfMeasure?.code
                                                                    }"
                                                                    [material]="{
                                                                        _id: detail.material?._id,
                                                                        code: detail.material?.code,
                                                                        UMPActive: detail.material?.UMPActive ?? false
                                                                    }"
                                                                    [companyUMPActive]="UMPACTIVE"
                                                                ></app-unit-measure-display>

                                                                <div class="items-start">
                                                                    <button mat-icon-button color="primary"
                                                                        (click)="openBatchesDetail(detail?.batches?.batchesLoaded, detail?.material, detail.totalLoaded.base, detail.totalLoaded.pararell, data.serial)"
                                                                        matTooltip="Ver lotes">
                                                                        <mat-icon aria-hidden="false"
                                                                            fontIcon="science"></mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </ng-container>

                                                    <!-- Entregado/Facturado -->
                                                    <ng-container matColumnDef="delivered">
                                                        <th mat-header-cell *matHeaderCellDef class="px-6 ">
                                                            Entregado/Facturado
                                                        </th>
                                                        <td mat-cell *matCellDef="let detail"
                                                            class=" text-sm whitespace-nowrap">
                                                            <div class="flex items-start">

                                                                <app-unit-measure-display
                                                                    [baseUnit]="{
                                                                        quantity: detail.totalDelivered.base,
                                                                        unitId: detail.baseUnitOfMeasure?._id,
                                                                        unitName: detail.baseUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.baseUnitOfMeasure?.code
                                                                    }"
                                                                    [parallelUnit]="{
                                                                        quantity: detail.totalDelivered.pararell,
                                                                        unitId: detail.pararellUnitOfMeasure?._id,
                                                                        unitName: detail.pararellUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.pararellUnitOfMeasure?.code
                                                                    }"
                                                                    [material]="{
                                                                        _id: detail.material?._id,
                                                                        code: detail.material?.code,
                                                                        UMPActive: detail.material?.UMPActive ?? false
                                                                    }"
                                                                    [companyUMPActive]="UMPACTIVE"
                                                                ></app-unit-measure-display>

                                                                <div class="items-start">
                                                                    <button mat-icon-button color="primary"
                                                                        (click)="openBatchesDetail(detail?.batches?.batchesDelivered, detail?.material, detail.totalDelivered.base, detail.totalDelivered.pararell, data.serial)"
                                                                        matTooltip="Ver lotes">
                                                                        <mat-icon aria-hidden="false"
                                                                            fontIcon="science"></mat-icon>
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </td>
                                                    </ng-container>

                                                    <!-- Buen Estado -->
                                                    <ng-container matColumnDef="returnedBE">
                                                        <th mat-header-cell *matHeaderCellDef class="px-6 ">
                                                            Buen Estado
                                                        </th>
                                                        <td mat-cell *matCellDef="let detail"
                                                            class=" text-sm whitespace-nowrap">
                                                            <div class="flex items-start">
                                                                <app-unit-measure-display
                                                                    [baseUnit]="{
                                                                        quantity: detail.totalReturnedBE.base,
                                                                        unitId: detail.baseUnitOfMeasure?._id,
                                                                        unitName: detail.baseUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.baseUnitOfMeasure?.code
                                                                    }"
                                                                    [parallelUnit]="{
                                                                        quantity: detail.totalReturnedBE.pararell,
                                                                        unitId: detail.pararellUnitOfMeasure?._id,
                                                                        unitName: detail.pararellUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.pararellUnitOfMeasure?.code
                                                                    }"
                                                                    [material]="{
                                                                        _id: detail.material?._id,
                                                                        code: detail.material?.code,
                                                                        UMPActive: detail.material?.UMPActive ?? false
                                                                    }"
                                                                    [companyUMPActive]="UMPACTIVE"
                                                                ></app-unit-measure-display>

                                                                <div class="items-start">
                                                                    <button mat-icon-button color="primary"
                                                                        (click)="openBatchesDetail(detail?.batches?.batchesReturnedBE, detail?.material, detail.totalReturnedBE.base, detail.totalReturnedBE.pararell, data.serial)"
                                                                        matTooltip="Ver lotes">
                                                                        <mat-icon aria-hidden="false"
                                                                            fontIcon="science"></mat-icon>
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </td>
                                                    </ng-container>

                                                    <!-- Mal Estado -->
                                                    <ng-container matColumnDef="returnedME">
                                                        <th mat-header-cell *matHeaderCellDef class="px-6 ">
                                                            Mal Estado
                                                        </th>
                                                        <td mat-cell *matCellDef="let detail"
                                                            class=" text-sm whitespace-nowrap">
                                                            <div class="flex items-start">

                                                                <app-unit-measure-display
                                                                    [baseUnit]="{
                                                                        quantity: detail.totalReturnedME.base,
                                                                        unitId: detail.baseUnitOfMeasure?._id,
                                                                        unitName: detail.baseUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.baseUnitOfMeasure?.code
                                                                    }"
                                                                    [parallelUnit]="{
                                                                        quantity: detail.totalReturnedME.pararell,
                                                                        unitId: detail.pararellUnitOfMeasure?._id,
                                                                        unitName: detail.pararellUnitOfMeasure?.name,
                                                                        unitAbbreviation: detail.pararellUnitOfMeasure?.code
                                                                    }"
                                                                    [material]="{
                                                                        _id: detail.material?._id,
                                                                        code: detail.material?.code,
                                                                        UMPActive: detail.material?.UMPActive ?? false
                                                                    }"
                                                                    [companyUMPActive]="UMPACTIVE"
                                                                ></app-unit-measure-display>

                                                            <div class="items-start">
                                                                    <button mat-icon-button color="primary"
                                                                        (click)="openBatchesDetail(detail?.batches?.batchesReturnedME, detail?.material, detail.totalReturnedME.base, detail.totalReturnedME.pararell, data.serial)"
                                                                        matTooltip="Ver lotes">
                                                                        <mat-icon aria-hidden="false"
                                                                            fontIcon="science"></mat-icon>
                                                                    </button>
                                                                </div>

                                                            </div>
                                                            
                                                        </td>
                                                    </ng-container>

                                                    <!-- Faltante -->
                                                    <ng-container matColumnDef="missing">
                                                        <th mat-header-cell *matHeaderCellDef class="px-6 ">
                                                            Faltante
                                                        </th>
                                                        <td mat-cell *matCellDef="let detail"
                                                            class=" text-sm whitespace-nowrap">
                                                            <app-unit-measure-display
                                                                [baseUnit]="{
                                                                    quantity: detail.totalMissing.base,
                                                                    unitId: detail.baseUnitOfMeasure?._id,
                                                                    unitName: detail.baseUnitOfMeasure?.name,
                                                                    unitAbbreviation: detail.baseUnitOfMeasure?.code
                                                                }"
                                                                [parallelUnit]="{
                                                                    quantity: detail.totalMissing.pararell,
                                                                    unitId: detail.pararellUnitOfMeasure?._id,
                                                                    unitName: detail.pararellUnitOfMeasure?.name,
                                                                    unitAbbreviation: detail.pararellUnitOfMeasure?.code
                                                                }"
                                                                [material]="{
                                                                    _id: detail.material?._id,
                                                                    code: detail.material?.code,
                                                                    UMPActive: detail.material?.UMPActive || true
                                                                }"
                                                                [companyUMPActive]="UMPACTIVE"
                                                            ></app-unit-measure-display>
                                                        </td>
                                                    </ng-container>

                                                    <!-- Filas de la tabla de detalles -->
                                                    <tr mat-header-row *matHeaderRowDef="materialDetailColumns"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: materialDetailColumns">
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
            </ng-template>
        </div>
    </div>
    <app-filter (onFilterEvent)="handleFilterSearch()" (onCleanEvent)="clearFilters()">
        <form [formGroup]="form">
            <div class="w-full mb-4 flex flex-col gap-y-4">
                <app-dates-filters [form]="form" [showStartTrip]="true" [showEndTrip]="true"
                    [showDateCreationRange]="true" />
                <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true" />
                <app-business-partners-filters [form]="form" [assignedUser]="true" />
            </div>
        </form>
    </app-filter>
</mat-sidenav-container>